import { AbstractModel, JsonObject, JsonProperty, DateConverter } from 'projects/core/src/public-api';
import { TrelloCard } from '../../../trello-misc/data/trello-card';
import { User } from 'projects/core/src/lib/login/data/user';
import { UserMention } from '../../../mentions/data/user-mention';
import { Project } from './project';

@JsonObject('model.comment.ProjectComment')
export class ProjectComment extends AbstractModel {

	@JsonProperty(Number, 'id')
	id: number;

	@JsonProperty(String, 'text')
	text?: string;

	@JsonProperty(ProjectComment, 'parentComment')
	parentComment?: ProjectComment;

	@JsonProperty([ProjectComment], 'replies')
	replies?: ProjectComment[];

	@JsonProperty(DateConverter, 'createdTime')
	createdTime?: Date;

	@JsonProperty(DateConverter, 'editTime')
	editTime?: Date;

	@JsonProperty(User, 'user')
	user?: User;

	@JsonProperty([UserMention], 'mentions')
	mentions?: UserMention[];

	@JsonProperty(Boolean, 'deleted')
	deleted?: boolean;

	@JsonProperty(Number, 'tasksDone')
	tasksDone?: number;

	@JsonProperty(Number, 'tasksTotal')
	tasksTotal?: number;

  moreThanYear?: boolean;

}
